import React, { useEffect, useState, useCallback } from "react";
import { adminClient } from "../../../lib/admin";
import { Star, ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

const FILTERS = ["pending", "approved", "rejected", ""];

export default function AdminReviews() {
  const client = adminClient();
  const [filter, setFilter] = useState("pending");
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    client.get("/admin/reviews", { params: { status: filter || undefined } }).then(({ data }) => setReviews(data.reviews)).catch(() => {}).finally(() => setLoading(false));
  }, [filter]);
  useEffect(() => { load(); }, [load]);

  const moderate = async (id, status) => { try { await client.put(`/admin/reviews/${id}`, { status }); toast.success(`Review ${status}`); load(); } catch { toast.error("Failed"); } };
  const del = async (id) => { try { await client.delete(`/admin/reviews/${id}`); toast.success("Deleted"); load(); } catch { toast.error("Failed"); } };

  return (
    <div data-testid="admin-reviews">
      <h2 className="text-xl font-black font-display mb-4">Reviews Moderation</h2>
      <div className="flex gap-2 mb-4">
        {FILTERS.map((f) => <button key={f || "all"} onClick={() => setFilter(f)} data-testid={`review-filter-${f || "all"}`} className={`text-xs font-bold uppercase tracking-wider px-3 py-2 ${filter === f ? "bg-taven-black text-white" : "bg-taven-gray"}`}>{f || "all"}</button>)}
      </div>
      {loading ? <Loader2 className="w-5 h-5 animate-spin text-taven-gold" /> :
        reviews.length === 0 ? <p className="text-sm text-muted-foreground">No reviews.</p> :
          <div className="space-y-3">
            {reviews.map((r) => (
              <div key={r.id} className="bg-white border border-black/10 p-4" data-testid="admin-review-item">
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <div className="flex items-center gap-2">
                    <div className="flex">{[1,2,3,4,5].map((i) => <Star key={i} className={`w-4 h-4 ${i <= r.rating ? "fill-taven-gold text-taven-gold" : "text-gray-300"}`} />)}</div>
                    {r.verified && <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase text-green-700 bg-green-50 px-2 py-0.5"><ShieldCheck className="w-3 h-3" /> Verified</span>}
                    <span className="text-[10px] font-bold uppercase bg-taven-gray px-2 py-0.5">{r.kind}: {r.target}</span>
                  </div>
                  <span className={`text-[10px] font-bold uppercase px-2 py-0.5 ${r.status === "approved" ? "bg-green-50 text-green-700" : r.status === "rejected" ? "bg-red-50 text-red-700" : "bg-yellow-50 text-yellow-700"}`}>{r.status}</span>
                </div>
                {r.title && <p className="font-bold text-sm mt-2">{r.title}</p>}
                <p className="text-sm text-muted-foreground mt-1">{r.body}</p>
                <p className="text-xs text-muted-foreground mt-1">— {r.author} · {r.email} · {new Date(r.created_at).toLocaleDateString()}</p>
                <div className="flex gap-2 mt-3">
                  <button onClick={() => moderate(r.id, "approved")} data-testid={`approve-${r.id}`} className="text-xs font-bold uppercase bg-green-600 text-white px-3 py-1.5 hover:bg-green-700">Approve</button>
                  <button onClick={() => moderate(r.id, "rejected")} data-testid={`reject-${r.id}`} className="text-xs font-bold uppercase border border-black/15 px-3 py-1.5 hover:bg-taven-gray">Reject</button>
                  <button onClick={() => del(r.id)} className="text-xs font-bold uppercase text-taven-red px-3 py-1.5 hover:underline">Delete</button>
                </div>
              </div>
            ))}
          </div>}
    </div>
  );
}
